export default {
  createExamSettings: "/examSettings/createExamSettings",
  getInstituteExamSetting: "/examSettings/getInstituteExamSetting",
  deleteExamRule: "/examSettings/deleteExamRule",
};
